exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clear-keyword[data-v-5a6fee04]{position:absolute;top:2px;right:35px;z-index:9}#search-autocomplete-atn[data-v-5a6fee04]{left:0;right:auto;max-width:280px;max-height:300px;overflow-x:hidden;overflow-y:auto}#search-autocomplete-atn a.dropdown-item[data-v-5a6fee04],#search-autocomplete-atn a.dropdown-item.active[data-v-5a6fee04],#search-autocomplete-atn a.dropdown-item.active[data-v-5a6fee04]:hover{color:#16181b!important}", ""]);

// exports
